<script>
import { BJumbotron } from "bootstrap-vue";

export default {
  extends: BJumbotron
};
</script>